import { Button, Grid, Paper } from "@mui/material"
import { Title } from "components/Common/Title"
import { OrganizationUsersReportDialog } from "components/Report/OrganizationUsersReportDialog"
import { CreateUserDialog } from "components/User/CreateUserDialog"
import { CreateUsersBatchDialog } from "components/User/CreateUsersBatchDialog"
import { UserList } from "components/User/UserList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import licensePoolService from "services/licensePoolService"
import licenseService from "services/licenseService"
import organizationService from "services/organizationService"
import userGroupService from "services/userGroupService"
import userService from "services/userService"
import { setLicensePools } from "slices/licensePoolSlice"
import { setLicenses } from "slices/licenseSlice"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setUserGroups } from "slices/userGroupSlice"
import { setUsers } from "slices/usersSlice"

export function OrganizationUsers() {
  const { id } = useParams()
  const dispatch = useAppDispatch()

  const currentOrganization = useAppSelector((state) => state.organization.currentOrganization)
  const users = useAppSelector((state) => state.users.users)
  const userGroups = useAppSelector((state) => state.usergroup.userGroups)
  const licenses = useAppSelector((state) => state.license.licenses)
  const licensePools = useAppSelector((state) => state.licensepool.licensePools)

  const [organizationUsersReportDialogOpen, setOrganizationUsersReportDialogOpen] = useState(false)

  const handleOrganizationUsersReportDialogOpen = (open: boolean) => {
    setOrganizationUsersReportDialogOpen(open)
  }

  useEffect(() => {
    if (currentOrganization === undefined && id) {
      organizationService
        .getOrganization(id)
        .then((organization) => {
          dispatch(setCurrentOrganization(organization))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (users.length < 1 && id) {
      userService
        .getOrganizationUsers(id)
        .then((users) => {
          dispatch(setUsers(users))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (userGroups.length < 1 && id) {
      userGroupService
        .getOrganizationUserGroups(id)
        .then((userGroups) => {
          dispatch(setUserGroups(userGroups))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (licenses.length < 1 && id) {
      licenseService
        .getOrganizationLicenses(id)
        .then((licenses) => {
          dispatch(setLicenses(licenses))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (licensePools.length < 1 && id) {
      licensePoolService
        .getOrganizationLicensePools(id)
        .then((licensePools) => {
          dispatch(setLicensePools(licensePools))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [
    currentOrganization,
    dispatch,
    id,
    licensePools.length,
    licenses.length,
    userGroups.length,
    users.length,
  ])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container paddingBottom={2}>
            <Grid item xs>
              <Title>USERS</Title>
            </Grid>
            <Grid item>
              {currentOrganization && <CreateUserDialog organization={currentOrganization} />}
            </Grid>
          </Grid>
          <UserList />
          <Grid container>
            <Grid item>
              {currentOrganization && <CreateUsersBatchDialog organization={currentOrganization} />}
            </Grid>
            <Grid item paddingLeft={2}>
              <Button
                data-testid="generateReportButton"
                variant="outlined"
                onClick={() => {
                  handleOrganizationUsersReportDialogOpen(true)
                }}
              >
                GENERATE REPORT
              </Button>
              <OrganizationUsersReportDialog
                open={organizationUsersReportDialogOpen}
                handleClose={() => handleOrganizationUsersReportDialogOpen(false)}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
